.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-ds-pill);
  padding: var(--spacing-ds-1);
}
